import {
  BOOKING_CONFIRMATION_ROUTE_PATHNAME,
  COMPLETE_BOOKING_ROUTE_PATHNAME,
  COMPLETE_PROFILE_ROUTE_PATHNAME,
  CONFIRM_YOUR_NUMBER_ROUTE_PATHNAME,
  CREATE_PASSWORD_ROUTE_PATHNAME,
  EMAIL_ROUTE_PATHNAME,
  ID_VERIFICATION_ROUTE_PATHNAME,
  PHONE_ROUTE_PATHNAME,
  REFERRAL_ROUTE_PATHNAME,
  SCHEDULE_ROUTE_VISIT_TYPE_ID_PARAM,
  SERVICES_ROUTE_PATHNAME,
} from 'router/routes/routePathnames';

export const POST_ONBOARDING_ROUTES = {
  services: {
    id: 'services',
    path: SERVICES_ROUTE_PATHNAME,
  },
  schedule: {
    id: 'schedule',
    path: SCHEDULE_ROUTE_VISIT_TYPE_ID_PARAM,
  },
  email: {
    id: 'email',
    path: EMAIL_ROUTE_PATHNAME,
  },
  phone: {
    id: 'phone',
    path: PHONE_ROUTE_PATHNAME,
  },
  confirmYourNumber: {
    id: 'confirm-you-number',
    path: CONFIRM_YOUR_NUMBER_ROUTE_PATHNAME,
  },
  completeProfile: {
    id: 'complete-profile',
    path: COMPLETE_PROFILE_ROUTE_PATHNAME,
  },
  createPassword: {
    id: 'create-password',
    path: CREATE_PASSWORD_ROUTE_PATHNAME,
  },
  completeBooking: {
    id: 'complete-booking',
    path: COMPLETE_BOOKING_ROUTE_PATHNAME,
  },
  bookingConfirmation: {
    id: 'booking-confirmation',
    path: BOOKING_CONFIRMATION_ROUTE_PATHNAME,
  },
};

const POST_BOOKING_ROUTES = {
  idVerification: {
    id: 'id-verification',
    path: ID_VERIFICATION_ROUTE_PATHNAME,
  },
};

export const ROUTES = {
  ...POST_ONBOARDING_ROUTES,
  ...POST_BOOKING_ROUTES,
  referral: {
    id: 'referral',
    path: REFERRAL_ROUTE_PATHNAME,
  },
};
